module.exports = __webpack_public_path__ + "static/media/silvercross.e238bf42.svg";